
/* eslint-disable @next/next/no-img-element */
import React, { useState, useEffect } from "react";
import Image from "next/image";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { ButtonBase } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import MenuPrimary from "../../menu/MenuPrimary";
import ShareIcon from "@mui/icons-material/Share";
import EditIcon from "@mui/icons-material/Edit";
import ImageIcon from "@mui/icons-material/Image";
import BackupTableIcon from "@mui/icons-material/BackupTable";
import InfoIcon from "@mui/icons-material/Info";
import OpenInNewOffIcon from "@mui/icons-material/OpenInNewOff";
import SecurityIcon from "@mui/icons-material/Security";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import DeleteIcon from '@mui/icons-material/Delete';
import { ReactSVG } from 'react-svg';
import Notification from "../../Notification";
import AlertDialog from "../../Dialog/AlertDialog";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useRouter } from "next/router";
import CircularProgress from "@mui/material/CircularProgress";
import { useStore } from "../../../../context/store";
import { getCanvas, renameCanvas, deleteCanvas } from "../../../../helpers/api-utils";

const CardPrimary = (props) => {
  const {
    data: { canvas_name, room_id, thumbnail, participants },
  } = props;

  const router = useRouter();
  const { ApiStore } = useStore()

  const [imgLoaded, setimgLoaded] = useState(false);
  const [notification, setnotification] = useState({
    open: false,
    loading: false,
    message: "",
    error: false,
  });
  const [openUpgradeAlertDialog, setOpenUpgradeAlertDialog] = React.useState(false);
  const [openDeleteCanvasAlertDialog, setOpenDeleteCanvasAlertDialog] = React.useState(false);

  const user = JSON.parse(window.localStorage.getItem("sketshare_user"));

  const UpgradeAlertDialogHandler = async (value: boolean) => {
    if (value === true) {
      setOpenUpgradeAlertDialog(false)
      router.push('/plans')
    } else if (value === false) {
      setOpenUpgradeAlertDialog(false)
    }
  }

  const copyStringToClipboard = (string: string) => {
    try {
      if (navigator.clipboard) {
        navigator.clipboard.write([
          new ClipboardItem({
            'text/plain': new Blob(["https://sketshare.com/canvas/" + string], { type: 'text/plain' }),
          }),
        ])
      }
      setnotification({
        open: true,
        loading: false,
        message: "Link copied to clipboard!",
        error: false,
      });
      setTimeout(
        () =>
          setnotification({
            open: false,
            loading: false,
            message: "",
            error: false,
          }),
        1500
      );
    } catch (err) {
      console.error(err)
      setnotification({
        open: true,
        loading: false,
        message: "Link copied to failed!",
        error: true,
      });
      setTimeout(
        () =>
          setnotification({
            open: false,
            loading: false,
            message: "",
            error: true,
          }),
        2000
      );
    }
  }

  const handleRenameCanvas = async () => {
    if (typeof window !== "undefined") {
      const user = JSON.parse(window.localStorage.getItem("sketshare_user"))
      const getCanvasName = prompt("Please rename the canvas", canvas_name);
      if (getCanvasName !== null) {


        try {
          const canvasData = await renameCanvas(user.token, { canvas_name: getCanvasName }, room_id)
          if (canvasData?.data) {
            setnotification({
              open: true,
              loading: false,
              message: "Canvas Renamed Successfully",
              error: false,
            });
            setTimeout(() => {
              setnotification({
                open: false,
                loading: false,
                message: "",
                error: false,
              })
              router.reload()
            }, 1500);
          }
        } catch (error) {
          console.log(error)
        }
      } else {
        console.log("canvas rename aborted")
      }
    }
  }

  const handleDeleteCanvas = async () => {
    if (typeof window !== "undefined") {
      const user = JSON.parse(window.localStorage.getItem("sketshare_user"))

      try {
        const canvasData = await deleteCanvas(user.token, room_id)
        if (canvasData?.data) {
          setnotification({
            open: true,
            loading: false,
            message: "Canvas Deleted Successfully",
            error: false,
          });
          setTimeout(() => {
            setnotification({
              open: false,
              loading: false,
              message: "",
              error: false,
            })
            router.reload()
          }, 1500);
        }
      } catch (error) {
        console.log(error)
      }
    }
  }

  const DeleteCanvasAlertDialogHandler = async (value: boolean) => {
    if (value === true) {
      setOpenDeleteCanvasAlertDialog(false)
      handleDeleteCanvas()
    } else if (value === false) {
      setOpenDeleteCanvasAlertDialog(false)
    }
  }

  const onClickShare = async () => {
    if (typeof window !== "undefined") {
      const user = JSON.parse(window.localStorage.getItem("sketshare_user"))
      try {
        const canvasData = await getCanvas(user.token, room_id)
        if (canvasData?.data) {
          window.localStorage.setItem("load_canvas_data", JSON.stringify(canvasData.data))
          ApiStore.setCanvasToLoad(true)
          ApiStore.setIsCanvasToSave(true)
          router.push("/canvas")
        }
      } catch (error) {
        console.log(error)
      }
    }
  }

  let canvasName = ''
  let canvasDate = ''
  if (canvas_name.includes('Untitled-') || canvas_name.includes('sketshare-')) {
    canvasName = canvas_name
    let splitData = canvas_name.substring(canvas_name.lastIndexOf('-') + 1);
    canvasDate = new Date(parseInt(splitData)).toLocaleTimeString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })
  }
  let finalCanvasName = "Untitled - " + canvasDate

  let imgPath = '';
  if (thumbnail) {
    if (thumbnail.includes('xml')) imgPath = thumbnail + "?token=" + user?.token;
    else if (thumbnail.includes('freepik') || thumbnail.includes('www.google.com')) {
      imgPath = thumbnail
    }
  } else {
    imgPath = thumbnail + "?token=" + user?.token
  }

  return (
    <div>
      <Notification
        notification={notification}
        setnotification={setnotification}
        error={notification.error}
      />
      <AlertDialog
        onSubmit={UpgradeAlertDialogHandler}
        title={"Upgrade plan"}
        content_text={"As a free user, you cannot start collaboration. For collaboration, upgrade to enterprise."}
        alertDialogOpen={openUpgradeAlertDialog}
        setAlertDialogOpen={setOpenUpgradeAlertDialog}
        cancal_text={"Cancel"}
        submit_text={"Upgrade"}
        submit_text_color={"#008000"}
      />
      <AlertDialog
        onSubmit={DeleteCanvasAlertDialogHandler}
        title={"Are you sure you want to delete this canvas?"}
        alertDialogOpen={openDeleteCanvasAlertDialog}
        setAlertDialogOpen={setOpenDeleteCanvasAlertDialog}
        cancal_text={"Cancel"}
        submit_text={"Yes"}
      />
      <div className="card-primary" onClick={onClickShare}>
        <div className="img">
          {imgPath.includes('xml') ?
            <ReactSVG src={imgPath} loading={() => <CircularProgress className="img-spinner" />} /> : <>
              {!imgLoaded && <CircularProgress className="img-spinner" />}
              <img
                src={imgPath}
                alt="canvas thumbnail"
                onLoad={() => setimgLoaded(true)}
              />
            </>
          }

          <div className="bg-card-dark" />
          <MenuPrimary
            className="icon"
            label="Menu"
            icon={<MoreVertIcon />}
            data={[
              // { name: "Start Collaboration", icon: <PeopleAltIcon sx={{ marginRight: "0.5rem" }} />, onClick: () => setOpenUpgradeAlertDialog(true) },
              // { name: "Share", icon: <ShareIcon sx={{ marginRight: "0.5rem" }} /> },
              { name: "Rename", icon: <EditIcon sx={{ marginRight: "0.5rem" }} />, onClick: () => handleRenameCanvas() },
              // { name: "Change cover", icon: <ImageIcon sx={{ marginRight: "0.5rem" }} /> },
              // { name: "Clone", icon: <BackupTableIcon sx={{ marginRight: "0.5rem" }} /> },
              // { name: "Board details", icon: <InfoIcon sx={{ marginRight: "0.5rem" }} /> },
              // { name: "Open in New Tab", icon: <OpenInNewIcon sx={{ marginRight: "0.5rem" }} /> },
              // { name: "Make Board Private", icon: <SecurityIcon sx={{ marginRight: "0.5rem" }} />, badge: "UPGRADE", onClick: () => router.push("/plans") },
              // { name: "Copy Canvas link", icon: <ContentCopyIcon sx={{ marginRight: "0.5rem" }} />, onClick: () => copyStringToClipboard(room_id) },
              { name: "Delete", icon: <DeleteIcon sx={{ marginRight: "0.5rem" }} />, onClick: () => setOpenDeleteCanvasAlertDialog(true) },
            ]}
          />
        </div>
        <div className="desc">
          <div className="left">
            <p className="name">{canvasName !== '' ? finalCanvasName : canvas_name}</p>
            {/* <p className="modified">Modified by me, Jun 14</p> */}
          </div>
          {/* <div className="right">
          <Tooltip title="Favourite">
            <ButtonBase
              className="icon"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <StarBorderIcon />
            </ButtonBase>
          </Tooltip>
        </div> */}
        </div>
        {participants?.length > 1 &&
          <div className="avatars">
            {participants?.map((part, index) =>
              <Tooltip title={part.name} key={index + 1} className="avatar">
                <img src={`${part.profile}?token=${user?.token}`} alt="user" />
              </Tooltip>
            )}
          </div>
        }
      </div>
    </div>
  );
};

export default CardPrimary;
